export default "__VITE_ASSET__mNHg6ujH__"